"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Exception = require("../../../Exceptions/Exception");

var _ExceptionCode = require("../../../Exceptions/ExceptionCode");

var _DeliveryPlatform = require("./DeliveryPlatform");

var _PlatformShippingStatus = require("./PlatformShippingStatus");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class DeliveryPlatformShipping {
  constructor() {
    _defineProperty(this, "id", null);

    _defineProperty(this, "type_id", null);

    _defineProperty(this, "status_id", null);

    _defineProperty(this, "external_id", null);

    _defineProperty(this, "created_at", null);
  }

  static fromObject(obj) {
    let deliveryPlatformShipping = new DeliveryPlatformShipping();
    Object.keys(obj || {}).forEach(key => {
      let value = obj[key];

      switch (key) {
        case 'id':
        case 'type_id':
        case 'status_id':
        case 'external_id':
        case 'created_at':
          deliveryPlatformShipping[key] = value;
          break;
      }
    });
    return deliveryPlatformShipping;
  }

  validate() {
    const type_id = this.type_id || '';
    const validTypes = Object.values(_DeliveryPlatform.DeliveryPlatform);

    if (!validTypes.includes(type_id)) {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_INVALID_DELIVERY_PLATFORM);
    }

    const status_id = this.status_id || '';
    const validStatuses = Object.values(_PlatformShippingStatus.PlatformShippingStatus);

    if (!validStatuses.includes(status_id)) {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_INVALID_SHIPPING_STATUS);
    }

    const external_id = this.external_id || '';

    if (!external_id) {
      throw new _Exception.Exception(_ExceptionCode.ExceptionCode.DELIVERY_INVALID_EXTERNAL_ID);
    }
  }

}

exports.default = DeliveryPlatformShipping;
;